<section class="banner-style-one">
  <div class="parallax"
       style="background-image: url(/assets/images/about.png);"></div>

  <div class="breadcrums">
    <div class="container">
      <div class="row">
        <ul>
          <li>
            <a [routerLink]="['/']">
              <i class="fa-solid fa-house"></i>
              <p>Inicio</p>
            </a>
          </li>
          <li class="current">
            <p>Nosotros</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section class="gap login-register">
  <div class="container">
    <div class="row">
      <!-- Login Box -->
      <div class="col-lg-6">
        <div class="box login [@fadeIn]">
          <h3>Inicia Sesión</h3>

          <!-- FormGroup + onLoginSubmit() -->
          <form [formGroup]="
             loginForm"
                (ngSubmit)="onLoginSubmit()">

            <!-- Email -->
            <input type="email"
                   formControlName="email"
                   placeholder="Correo electrónico">
            <!-- Mensajes de error para email -->
            <div class="error-msg"
                 *ngIf="emailFieldLogin?.invalid && (emailFieldLogin?.touched || emailFieldLogin?.dirty)">
              <small *ngIf="emailFieldLogin?.errors?.['required']">El correo es obligatorio</small>
              <small *ngIf="emailFieldLogin?.errors?.['email']">El formato de correo es inválido</small>
            </div>

            <!-- Password -->
            <input type="password"
                   formControlName="password"
                   placeholder="Contraseña">
            <!-- Mensajes de error para password -->

            <div class="error-msg"
                 *ngIf="passwordFieldLogin?.invalid && (passwordFieldLogin?.touched || passwordFieldLogin?.dirty)">
              <small *ngIf="passwordFieldLogin?.errors?.['required']">La contraseña es obligatoria</small>
              <small *ngIf="passwordFieldLogin?.errors?.['minlength']">Mínimo 6 caracteres</small>
            </div>

            <div class="remember">
              <div class="first">
                <input type="checkbox"
                       formControlName="rememberMe"
                       id="checkbox">
                <label for="checkbox">Recuérdame</label>
              </div>
              <div class="second">
                <a href="javascript:void(0)">¿Olvidaste tu contraseña?</a>
              </div>
            </div>

            <!-- Botón de enviar -->
            <button type="submit"
                    class="theme-btn"
                    [disabled]="isLoading">
              {{ isLoading ? 'Iniciando...' : 'Iniciar sesión' }}
            </button>

            <!-- Mensaje de error general (p.ej. 401 credenciales inválidas) -->
            <div class="error-msg"
                 *ngIf="loginErrorMsg">
              {{ loginErrorMsg }}
            </div>
          </form>

          <div *ngIf="isLoading"
               [@fadeOverlay]
               class="loading-overlay">
            <div class="spinner"></div>
          </div>


          <!-- <div *ngIf="isLoading"
               class="loading-overlay">
            <div class="spinner"></div>
            <p>Iniciando sesión...</p>
          </div> -->
        </div>

      </div>

      <!-- Register Box -->
      <div class="col-lg-6">
        <div class="box register [@fadeInRegister]">
          <h3>Regístrate ahora</h3>

          <form [formGroup]="registerForm"
                (ngSubmit)="onRegisterSubmit()">
            <!-- Email -->
            <input type="email"
                   formControlName="email"
                   placeholder="Correo electrónico">
            <!-- Errores de email -->
            <div class="error-msg"
                 *ngIf="emailFieldRegister?.invalid && (emailFieldRegister?.touched || emailFieldRegister?.dirty)">
              <small *ngIf="emailFieldRegister?.errors?.['required']">
                *El correo es obligatorio
              </small>
              <small *ngIf="emailFieldRegister?.errors?.['email']">
                *Formato de correo inválido
              </small>
            </div>

            <!-- Password -->
            <input type="password"
                   formControlName="password"
                   placeholder="Crea una contraseña">
            <!-- Errores de password -->
            <div class="error-msg"
                 *ngIf="passwordFieldRegister?.invalid && (passwordFieldRegister?.touched || passwordFieldRegister?.dirty)">
              <small *ngIf="passwordFieldRegister?.errors?.['required']">
                *La contraseña es obligatoria
              </small>
              <small *ngIf="passwordFieldRegister?.errors?.['minlength']">
                *Mínimo 6 caracteres
              </small>
            </div>

            <!-- Confirm Password -->
            <input type="password"
                   formControlName="confirmPassword"
                   placeholder="Confirmar contraseña">
            <!-- Errores de confirm -->

            <div class="error-msg"
                 *ngIf="confirmPasswordFieldRegister?.invalid && (confirmPasswordFieldRegister?.touched || confirmPasswordFieldRegister?.dirty)">
              <small *ngIf="confirmPasswordFieldRegister?.errors?.['required']">
                *Debes confirmar la contraseña
              </small>
            </div>

            <div class="error-msg"
                 *ngIf="confirmPasswordFieldRegister?.touched
            && registerForm?.errors?.['mismatch']">
              <small>Las contraseñas no coinciden</small>
            </div>

            <p>
              Al registrarme, acepto las Condiciones del servicio de Tiger Zen Do y su Política de privacidad.
            </p>

            <button type="submit"
                    class="theme-btn"
                    [disabled]="isLoading">
              {{ isLoading ? 'Registrando...' : 'Crear cuenta' }}
            </button>

            <!-- Mensaje de error general del registro (si falla la petición) -->
            <div class="error-msg"
                 *ngIf="registerErrorMsg">
              {{ registerErrorMsg }}
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
